$(document).ready(function() {

    //$('#modalAgree').modal({backdrop: 'static', keyboard: false});
    //$('#modalAgree').modal('show');
    var showBackToWebsite = $('#showBackToWebsite').val();

    if(showBackToWebsite != true)
    {
        $('#btnBackToSite').hide();
    }

    //DISABLE RIGHT CLICK
    $(document).bind("contextmenu", function(e) { return false; });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $("body").tooltip({ selector: '[data-toggle=tooltip]' });

    $('.openRegistrationDiv').on('click', function () {

        $('.loginCard').addClass('card-hidden');
        $('#loginDiv').removeClass('d-block').addClass('d-none');

        $('#registrationDiv').removeClass('d-none').addClass('d-block');
        setTimeout(function() {
            // after 1000 ms we add the class animated to the login/register card
            $('.registrationCard').removeClass('card-hidden');
        }, 100);
    });

    $('#openLoginDiv').on('click', function () {

        $('.registrationCard').addClass('card-hidden');
        $('#registrationDiv').removeClass('d-block').addClass('d-none');

        $('#loginDiv').removeClass('d-none').addClass('d-block');
        setTimeout(function() {
            // after 1000 ms we add the class animated to the login/register card
            $('.loginCard').removeClass('card-hidden');
        }, 100);
    });

    $('#btnCancel').on('click', function () {
        $('.registrationDetailsCard').addClass('card-hidden');
        $('#registrationDetailsDiv').removeClass('d-block').addClass('d-none');

        $('#loginDiv').removeClass('d-none').addClass('d-block');
        setTimeout(function() {
            // after 1000 ms we add the class animated to the login/register card
            $('.loginCard').removeClass('card-hidden');
        }, 100);
    });

    var verifiedMember;

    $("#verifyMembership").on("click" , function () {
        let sn = $('#sn').val();
        let pin = $('#pin').val();
        verifiedMember = null;

        if(sn.trim() == "")
        {
            swal({
                title: "Serial Number is required!",
                text: "Please input your Serial Number.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if(pin.trim() == "")
        {
            swal({
                title: "PIN is required!",
                text: "Please input your PIN.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        //DISPLAY CONTENT FROM DATABASE
        $.ajax({
            type: "GET",
            url: "/verifyMembership",
            data: { sn : sn , pin : pin },
            contentType: "application/json; charset=utf-8",
            beforeSend:  function() {
                swal({ title: 'Verifying Member..', onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
            },
            error: function (jqXHR, exception) {
                swal.close();
                errorHandling(jqXHR);
            },
            success: function (data) {
                swal.close();

                if(data.error)
                {
                    swal({
                        title: data.message,
                        text: data.message2,
                        type: "info",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success"
                    });
                }
                else
                {
                    swal({
                        title: "Membership Validated!",
                        text: "Please complete your details to finish your registration.",
                        type: "success",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success"
                    }).then((result) => {


                        $('#rank').val("N/A");

                        $('#brCode').val("");
                        $('#dob').val("");
                        $('#scno').val("");

                        $('#branchName').val("");
                        $('#serialNumber').val("");
                        $('#lastName').val("");
                        $('#firstName').val("");
                        $('#middleName').val("");

                        $('#remail').val("");
                        $('#rmobileNo').val("");
                        $('#rpassword').val("");
                        $('#confirmPassword').val("");
                        /*
                        if(data.rank.trim() != "")
                        {
                        $('#rank').val(data.rank.trimEnd());
                        }
                        */
                        $('#brCode').val(data.BR.trimEnd());
                        $('#dob').val(data.DOB.trimEnd());
                        $('#scno').val(data.SCNO.trimEnd());

                        $('#branchName').val(data.BRNAME.trimEnd());
                        $('#serialNumber').val(data.AFSN.trimEnd());
                        $('#lastName').val(data.FN.trimEnd());
                        $('#firstName').val(data.GN.trimEnd());
                        $('#middleName').val(data.MN.trimEnd());
                        /*
                        if(data.email.trim() != "")
                        {
                        //$('#remail').val(data.email.trimEnd());
                        }

                        if(data.cell.trim() != "")
                        {
                        //$('#rmobileNo').val(data.cell.trimEnd());
                        }
                        */
                        $('#rpassword').val("");
                        $('#confirmPassword').val("");

                        $('.registrationCard').addClass('card-hidden');
                        $('#registrationDiv').removeClass('d-block').addClass('d-none');


                        verifiedMember = data;

                        $('#registrationDetailsDiv').removeClass('d-none').addClass('d-block');
                        setTimeout(function() {
                            // after 1000 ms we add the class animated to the login/register card
                            $('.registrationDetailsCard').removeClass('card-hidden');
                        }, 100);

                    });
                }
            },
        });
    });

    setTimeout(function() {
        // after 1000 ms we add the class animated to the login/register card
        $('.loginCard').removeClass('card-hidden');
        //$('.registrationDetailsCard').removeClass('card-hidden');
    }, 100);

    $('#rpassword').pwstrength(
        {
            ui: {
                viewports: {
                    progress: ".rpassword_viewport_progress",
                },
                showVerdictsInsideProgressBar: true ,
                //progressBarExtraCssClasses: "progress-bar progress-bar-striped",
            },
            common: {
                debug: true,
                zxcvbn: true,
            }
        }
    );

    $('#npassword').pwstrength(
        {
            ui: {
                viewports: {
                    progress: ".npassword_viewport_progress",
                },
                showVerdictsInsideProgressBar: true ,
                //progressBarExtraCssClasses: "progress-bar progress-bar-striped",
            },
            common: {
                debug: true,
                zxcvbn: true,
            }
        }
    );

    $('#remail').on('input', function () {
        var userinput = $(this).val();
        var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

        if(userinput === "")
        {
        $("#emailProgressBar").html('<div id="emailMeter" class="progress-bar" data-score="0"> </div>');
        }
        else if (!expr.test(userinput))
        {
        $("#emailProgressBar").html('<div id="emailMeter" class="progress-bar progress-bar-danger" data-score="0" style="width: 100%;"> Please input valid email address. </div>');
        }
        else
        {
        $("#emailProgressBar").html('<div id="emailMeter" class="progress-bar progress-bar-success" data-score="1" style="width: 100%;"> Valid email address. </div>');
        }
    });

    $('#rmobileNo').on('input', function () {
        var userinput = $(this).val();
        //var password = $("#rpassword").val();

        if(userinput == "")
        {
        $("#rmobileNoProgressBar").html('<div id="rmobileNoMeter" class="progress-bar" data-score="0" >  </div>');
        }
        else if (userinput.length != 11 || userinput.substr(0, 2) != "09")
        {
        $("#rmobileNoProgressBar").html('<div id="rmobileNoMeter" class="progress-bar progress-bar-danger" data-score="0" style="width: 100%;"> Invalid mobile no. </div>');
        }
        else
        {
        $("#rmobileNoProgressBar").html('<div id="rmobileNoMeter" class="progress-bar progress-bar-success" data-score="1" style="width: 100%;"> Valid mobile no. </div>');
        }
    });

    $('#rpassword').on('input', function () {
        $('#confirmPassword').trigger('input');
    });

    $('#npassword').on('input', function () {
        $('#nconfirmPassword').trigger('input');
    });

    $('#confirmPassword').on('input', function () {
        var userinput = $(this).val();
        var password = $("#rpassword").val();

        if(userinput === "")
        {
        $("#confirmPasswordProgressBar").html('<div id="confirmPasswordMeter" class="progress-bar" data-score="0">  </div>');
        }
        else if(password == "")
        {
        $("#confirmPasswordProgressBar").html('<div id="confirmPasswordMeter" class="progress-bar" data-score="0">  </div>');
        }
        else if (userinput != password)
        {
        $("#confirmPasswordProgressBar").html('<div id="confirmPasswordMeter" class="progress-bar progress-bar-danger" data-score="0" style="width: 100%;"> Password didn\'t match. </div>');
        }
        else
        {
        $("#confirmPasswordProgressBar").html('<div id="confirmPasswordMeter" class="progress-bar progress-bar-success" data-score="1" style="width: 100%;"> Password match. </div>');
        }
    });

    $('#nconfirmPassword').on('input', function () {
        var userinput = $(this).val();
        var password = $("#npassword").val();

        if(userinput === "")
        {
        $("#nconfirmPasswordProgressBar").html('<div id="nconfirmPasswordMeter" class="progress-bar" data-score="0">  </div>');
        }
        else if(password == "")
        {
        $("#nconfirmPasswordProgressBar").html('<div id="nconfirmPasswordMeter" class="progress-bar" data-score="0">  </div>');
        }
        else if (userinput != password)
        {
        $("#nconfirmPasswordProgressBar").html('<div id="nconfirmPasswordMeter" class="progress-bar progress-bar-danger" data-score="0" style="width: 100%;"> Password didn\'t match. </div>');
        }
        else
        {
        $("#nconfirmPasswordProgressBar").html('<div id="nconfirmPasswordMeter" class="progress-bar progress-bar-success" data-score="1" style="width: 100%;"> Password match. </div>');
        }
    });

    //$('#modalAgree').modal({backdrop: 'static', keyboard: false});
    $('#tc').on('change', function()
    {
        if(this.checked == true)
        {
            $('#modalAgree').modal({backdrop: 'static', keyboard: false});
            $('#modalAgree').modal('show');
            setTimeout(function(){
                $('#pdf_content').focus();
            }, 100);
        }
    });

    $('#btnRegister').on('click', function() {
        //var brCode = verifiedMember.br.trimEnd();
        //var dob = verifiedMember.dob2.trimEnd();
        // var brName = verifiedMember.brname.trimEnd();
        // var scno = verifiedMember.scno.trimEnd();
        // var sn = verifiedMember.sn.trimEnd();
        // var fn = verifiedMember.fn.trimEnd();
        // var gn = verifiedMember.gn.trimEnd();
        // var mn = verifiedMember.mn.trimEnd();

        var emailMeter = $("#emailMeter").data("score");
        var rmobileNoMeter = $("#rmobileNoMeter").data("score");
        var passwordMeter = $('.rpassword_viewport_progress .password-verdict').text();
        //var passwordMeter = $("#passwordMeter").data("score");
        var confirmPasswordMeter = $("#confirmPasswordMeter").data("score");

        var remail = $("#remail").val();
        var rmobileNo = $("#rmobileNo").val();
        var rpassword = $("#rpassword").val();
        var confirmPassword = $("#confirmPassword").val();

        var nl = $("#nl").prop('checked');
        var tc = $("#tc").prop('checked');

        if((remail.trim()).length == 0)
        {
            swal({
                title: "Email is required!",
                text: "Please input your email.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if((rmobileNo.trim()).length == 0)
        {
            swal({
                title: "Mobile No. is required!",
                text: "Please input your mobile no.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if(remail.trim().length != 0)
        {
            if(emailMeter == 0)
            {
                swal({
                title: "Incorrect Email!",
                text: "Please input correct email.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
                });
                return;
            }
        }

        if(rmobileNo.trim().length != 0)
        {
            if(rmobileNoMeter == 0)
            {
                swal({
                title: "Incorrect Mobile No!",
                text: "Please input correct mobile no.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
                });
                return;
            }
        }

        if((rpassword.trim()).length == 0)
        {
            swal({
                title: "Password is required!",
                text: "Please input your password",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if(passwordMeter == "Weak")
        {
            swal({
                title: "Password Requirements!",
                html: "Password must be 6 character<br>Password meter must not <b>Weak</b>.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if((confirmPassword.trim()).length == 0)
        {
            swal({
                title: "No Confirm Password!",
                text: "Please input confirm password",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if(confirmPasswordMeter == 0)
        {
            swal({
                title: "Confirm Password!",
                text: "Password didn't match.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if(tc == false)
        {
            swal({
                title: "Please read the\nTerms and Condition!",
                text: "In order to proceed your registration.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        let formData = new FormData(document.getElementById("registrationDetailsForm"));

        $.ajax({
            type: "POST",
            url: "/registerMembership",
            data: formData,
            contentType: "application/json; charset=utf-8",
            cache: false,
            contentType: false,
            processData:false,
            beforeSend:  function() {
                swal({ title: 'Creating Account..', onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
            },
            error: function (jqXHR, exception) {
                swal.close();

                errorHandling(jqXHR);
            },
            success: function (data) {
                swal.close();

                if(data.error)
                {
                    swal({
                        title: data.message,
                        text: data.message2,
                        type: "info",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success"
                    });
                }
                else
                {
                    swal({
                        title: "Registration Success",
                        text: "Proceed to Login.",
                        type: "success",
                        buttonsStyling: false,
                        allowOutsideClick:false,
                        confirmButtonText: "Go to Dashboard",
                        confirmButtonClass: "btn btn-success"
                    }).then((result) => {
                        swal({ title: 'Signing in..', onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });

                        $('.registrationDetailsCard').addClass('card-hidden');
                        $('#registrationDetailsDiv').removeClass('d-block').addClass('d-none');

                        $('#loginDiv').removeClass('d-none').addClass('d-block');
                        setTimeout(function() {
                            // after 1000 ms we add the class animated to the login/register card
                            $('.loginCard').removeClass('card-hidden');
                        }, 100);

                        $('#email').val(remail);
                        $('#password').val(rpassword);

                        //$('#btnLogin').triggerHandler('click');
                        $('#btnLogin').trigger('click');

                        setTimeout(function() {
                            // after 1000 ms we add the class animated to the login/register card
                            swal.close();
                        }, 5000);
                    });

                    //$('#btnCancel').trigger('click');
                }
            }
        });
    });

    $('#btnUpdatePassword').on('click', function()
    {
        var password = $("#npassword").val();
        var confirmPassword = $("#nconfirmPassword").val();
        var passwordMeter = $('.npassword_viewport_progress .password-verdict').text();
        var confirmPasswordMeter = $("#nconfirmPasswordMeter").data("score");

        if((password.trim()).length == 0)
        {
            swal({
                title: "Password is required!",
                text: "Please input your password",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if(passwordMeter == "Weak")
        {
            swal({
                title: "Password Requirements!",
                html: "Password must be 6 character<br>Password meter must not <b>Weak</b>.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if((confirmPassword.trim()).length == 0)
        {
            swal({
                title: "No Confirm Password!",
                text: "Please input confirm password",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        if(confirmPasswordMeter == 0)
        {
            swal({
                title: "Confirm Password!",
                text: "Password didn't match.",
                type: "info",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success"
            });
            return;
        }

        let formData = new FormData();
        formData.append('password', password);

        $.ajax({
            type: "POST",
            url: "/updateAccountPassword",
            data: formData,
            contentType: "application/json; charset=utf-8",
            cache: false,
            contentType: false,
            processData:false,
            beforeSend:  function() {
                swal({ title: 'Updating Password...', onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
            },
            error: function (jqXHR, exception) {
                swal.close();

                errorHandling(jqXHR);
            },
            success: function (data) {
                swal.close();

                if(data.error)
                {
                    swal({
                        title: data.message,
                        text: data.message2,
                        type: "info",
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success"
                    });
                }
                else
                {
                    swal({
                        title: "Password Updated",
                        text: "Proceed to Login.",
                        type: "success",
                        buttonsStyling: false,
                        allowOutsideClick:false,
                        confirmButtonText: "Login",
                        confirmButtonClass: "btn btn-success"
                    }).then((result) => {

                        $('.forgotPasswordDetailsCard').addClass('card-hidden');
                        $('#forgotPasswordDetailsDiv').removeClass('d-block').addClass('d-none');

                        $('#loginDiv').removeClass('d-none').addClass('d-block');
                        setTimeout(function() {
                            // after 1000 ms we add the class animated to the login/register card
                            $('.loginCard').removeClass('card-hidden');
                        }, 100);
                    });
                }
            }
        });


    })

    $("#forgotPassword").on("click" , function () {

        swal({
            title:"Find your account?",
            html: "Please enter your <b>Email</b> or <b>Mobile Number</b><br> to search for your account.",
            type: "question",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            input: 'text',
            showCancelButton: true,
            cancelButtonClass: "btn btn-danger",
            allowOutsideClick: false,
            inputPlaceholder: 'Email or mobile number',
            inputValidator: (value) => {
                if (!value) {
                    return ' '
                }
            },
            confirmButtonText: 'Search',
            confirmButtonColor: '#3085d6',
        }).then((result) => {
        if (result.value) {

            let formData = new FormData();
            formData.append('verify', result.value);
            formData.append('verifyBy', "FindAccount");

            $.ajax({
                type: "POST",
                url: "/verifyAccount",
                data: formData,
                contentType: "application/json; charset=utf-8",
                cache: false,
                contentType: false,
                processData:false,
                beforeSend:  function() {
                    swal({ title: 'Searching Account....', onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
                },
                error: function (jqXHR, exception) {
                    swal.close();

                    errorHandling(jqXHR);
                },
                success: function (data) {
                    swal.close();

                    if(data.error)
                    {
                        swal({
                            title: data.message,
                            text: data.message2,
                            type: "info",
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-success"
                        });
                    }
                    else
                    {
                        validateSerialNumber(data, 3);
                    }
                }
            });
        }
        });
    });
}); //document ready

function validateSerialNumber(data, attempt)
{
    if (data.id === undefined || data.id == null) {
        swal({
            title: "Unable to Verify Account.",
            text: "An error occurred. Please try again later.",
            type: "error",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success"
        });
    }
    else {
        swal({
            title:"Are you " + data.firstName + " " + data.lastName  + "?",
            html: "Please input your <b>Serial Number</b> to confirm.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            input: 'text',
            showCancelButton: true,
            cancelButtonClass: "btn btn-danger",
            allowOutsideClick: false,
            inputPlaceholder: 'Serial Number',
            inputValidator: (value) => {
                if (!value) {
                    return '&nbsp'
                }
            },
            type: 'question',
            confirmButtonText: 'Confirm',
            confirmButtonColor: '#3085d6',
        }).then((result2) => {
            if (result2.value) {

                let formData = new FormData();
                formData.append('verify', data.id);
                formData.append('verify2', result2.value);
                formData.append('verifyBy', "SerialNumber");

                $.ajax({
                    type: "POST",
                    url: "/verifyAccount",
                    data: formData,
                    contentType: "application/json; charset=utf-8",
                    cache: false,
                    contentType: false,
                    processData:false,
                    beforeSend:  function() {
                        swal({ title: 'Verifying Account....', onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
                    },
                    error: function (jqXHR, exception) {
                        swal.close();

                        errorHandling(jqXHR);
                    },
                    success: function (data3) {
                        swal.close();

                        if(data3.error)
                        {
                            swal({
                                title: data3.message,
                                text: data3.message2,
                                type: "info",
                                buttonsStyling: false,
                                confirmButtonClass: "btn btn-success"
                            });
                        }
                        else
                        {
                            if((data3.SN).toUpperCase() == (result2.value).toUpperCase())
                            {
                                verifiedMember = data3;

                                if(data3.email != null && data3.mobileNo == null)
                                {
                                    sendEmailOTP(data3.email);
                                }
                                else if(data3.email == null && data3.mobileNo != null)
                                {
                                    sendMobileOTP(data.mobileNo);
                                }
                                else if(data3.email != null && data3.mobileNo != null)
                                {
                                    swal({
                                        title: "Account Confirmed!",
                                        html: "Choose between <b>Email</b> or <b>Mobile Number</b>\nto receive your OTP.",
                                        type: "success",
                                        buttonsStyling: false,
                                        allowOutsideClick:false,
                                        confirmButtonText: "via EMAIL <span class='material-icons'>email</span>",
                                        confirmButtonClass: "btn btn-success",
                                        showCancelButton: true,
                                        cancelButtonText: "via MOBILE NUMBER <span class='material-icons'>sms</span>",
                                        cancelButtonClass: "btn btn-success",
                                    }).then((accountConfirmedResult) => {
                                        if (accountConfirmedResult.value) {
                                            // Handle the confirm button (Email) click
                                            sendEmailOTP(data3.email);
                                        } else if (accountConfirmedResult.dismiss === Swal.DismissReason.cancel) {
                                            // Handle the cancel button (Mobile) click
                                            sendMobileOTP(data3.mobileNo);
                                        }
                                    });
                                }
                            }
                            else
                            {
                                if(attempt == "0")
                                {
                                    swal({
                                        title: "Exceed the maximum attempt!",
                                        text: "Please try again later.",
                                        type: "danger",
                                        buttonsStyling: false,
                                        allowOutsideClick:false,
                                        confirmButtonText: "Try Again Later",
                                        confirmButtonClass: "btn btn-success"
                                    }).then((result) => {

                                    });
                                }
                                else
                                {
                                    swal({
                                        title: "Incorrect Serial Number!",
                                        text: "You have " + attempt + " attempt left.",
                                        type: "error",
                                        buttonsStyling: false,
                                        allowOutsideClick:false,
                                        confirmButtonText: "TRY AGAIN",
                                        confirmButtonClass: "btn btn-success"
                                    }).then((incorrectResult) => {
                                        if(incorrectResult)
                                        {
                                            attempt--;
                                            validateSerialNumber(data,attempt);
                                        }
                                    });
                                }
                            }
                        }
                    }
                });

            }
        });
    }

}

function sendMobileOTP(registeredMobileNo)
{
    let formData = new FormData();
    formData.append('mobileNo', registeredMobileNo);

    $.ajax({
        type: "POST",
        url: "/sendMobileNoVerification",
        data: formData,
        contentType: "application/json; charset=utf-8",
        cache: false,
        contentType: false,
        processData:false,
        beforeSend:  function() {
            swal({ title: 'Sending Mobile Verification to..\n' + registeredMobileNo, onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
        },
        error: function (jqXHR, exception) {
            swal.close();

            errorHandling(jqXHR);
        },
        success: function (data) {
            swal.close();

            if(data.error)
            {
                swal({
                    title: "Unable to Send Mobile Verification",
                    text: data.message,
                    type: "info",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success"
                });
            }
            else
            {
                verificationOTP("MobileNo");
            }
        }
    });
}

function sendEmailOTP(registeredEmail)
{
    let formData = new FormData();
    formData.append('email', registeredEmail);

    $.ajax({
        type: "POST",
        url: "/sendEmailVerification",
        data: formData,
        contentType: "application/json; charset=utf-8",
        cache: false,
        contentType: false,
        processData:false,
        beforeSend:  function() {
            swal({ title: 'Sending Email Verification to..\n' + registeredEmail, onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
        },
        error: function (jqXHR, exception) {
            swal.close();

            errorHandling(jqXHR);
        },
        success: function (data) {
            swal.close();

            if(data.error)
            {
                swal({
                    title: "Unable to Send Email Verification",
                    text: data.message,
                    type: "info",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success"
                });
            }
            else
            {
                verificationOTP("Email");
            }
        }
    });
}

function verificationOTP(fromOTP)
{
    swal({
        title:"Confirm your One-Time Pin!",
        html: 'Please enter the 6 Digit OTP.',
        //html: 'Please enter the 6 Digit OTP. <br> <a href="#" autofocus>Resend OTP</a>',
        type: "question",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success",
        input: 'text',
        allowOutsideClick: false,
        inputPlaceholder: 'OTP',
        inputValidator: (value) => {
            if (!value) {
                return ' ';
            }

            // if(value != OTP)
            // {
            //     swal({
            //         title: "Incorrect One-Time Pin",
            //         text: "Please input the correct OTP.",
            //         type: "info",
            //         buttonsStyling: false,
            //         allowOutsideClick:false,
            //         confirmButtonText: "Try Again",
            //         confirmButtonClass: "btn btn-success"
            //     }).then((result) => {
            //         verificationOTP(OTP, fromOTP);
            //     });

            //     return ' ';
            // }
        },
        confirmButtonText: 'Confirm',
        confirmButtonColor: '#3085d6',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonClass: "btn btn-danger",
    }).then((result) => {
        if (result.value) {

            let formData = new FormData();
            formData.append('otp', result.value);

            $.ajax({
                type: "POST",
                url: "/verifyOTP",
                data: formData,
                contentType: "application/json; charset=utf-8",
                cache: false,
                contentType: false,
                processData:false,
                beforeSend:  function() {
                    swal({ title: 'Verifying OTP....', onOpen: () => swal.showLoading(), allowOutsideClick: () => !swal.isLoading() });
                },
                error: function (jqXHR, exception) {
                    swal.close();

                    errorHandling(jqXHR);
                },
                success: function (data) {
                    swal.close();

                    if(data.error)
                    {
                        swal({
                            title: data.message,
                            text: data.message2,
                            type: "info",
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-success"
                        });
                    }
                    else
                    {
                        if(!data.success)
                        {
                            swal({
                                title: "Incorrect One-Time Pin",
                                text: "Please input the correct OTP.",
                                type: "info",
                                buttonsStyling: false,
                                allowOutsideClick:false,
                                confirmButtonText: "Try Again",
                                confirmButtonClass: "btn btn-success"
                            }).then((result) => {
                                verificationOTP(fromOTP);
                            });
                        }
                        else
                        {
                            swal({
                                title: "One-Time Pin Matched!",
                                text: "You can now create a new password",
                                type: "success",
                                buttonsStyling: false,
                                allowOutsideClick:false,
                                confirmButtonText: "Create a new password",
                                confirmButtonClass: "btn btn-success"
                            }).then((result) => {
                                $('.loginCard').addClass('card-hidden');
                                $('#loginDiv').removeClass('d-block').addClass('d-none');

                                $('#forgotPasswordDetailsDiv').removeClass('d-none').addClass('d-block');
                                setTimeout(function() {
                                    // after 1000 ms we add the class animated to the login/register card
                                    $('.forgotPasswordDetailsCard').removeClass('card-hidden');
                                }, 100);
                            });
                        }
                    }
                }
            });
        }
    });
}

function errorHandling(jqXHR)
{
  console.log(jqXHR.responseText);
  swal({ title: jqXHR.status + " " + jqXHR.statusText, text: "Please try again later.", type: "error", buttonsStyling: false, confirmButtonClass: "btn btn-success"});
}

console.log('%c STOP !! ', 'background-color: #FF0000 ; color: #ffffff ; font-weight: bold ; padding: 4px ; font-size:100px');
console.log('%c This is a browser feature intended for developers.',"color: blue; font-size: 18px");
console.log('%c If someone told you to copy-paste something here to enable a Member\'s Portal feature or "hack" someone\'s account,',"color: blue; font-size: 18px");
console.log('%c it is a scam and will give them access to your Member\'s Portal account.',"color: blue; font-size: 18px");

//DISABLE DRAG
window.ondragstart = function() { return false; }

//DISABLE RIGHTCLICK
$(document). bind("contextmenu", function(e) { return false; });
